<div class="card">
	<div class="card-header">
		<h1>Historial de cargas de DTE</h1>
	</div>
	<div class="card-body">
		<h5>Filtros</h5>
		<div class="row">
			<div class="col-sm-9 form-group">
				<label for="company" class="form-label">Empresa:</label>
				<div class="input-group">
					<app-input-autocomplete (changeStatus)="selectCompany($event.filterElement)"
						(inputMethod)="searchCompany()" [allBorderRadius]="true" [filterElements]="companies"
						[placeholder]="'Busca una empresa'" [custom]="true" [inputs]="inputCompany">
						<ng-template #itemsTemplate let-filter>
							<!-- This is the content that will be projected -->
							<div items>
								<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
									{{filter.companyName?filter.companyName:filter.name}}</h5>
								<span class="text-muted" style="color: white !important;">{{filter.alphanumericId}} -
									NIT: <b>{{filter.companyNIT?filter.companyNIT:filter.nit}}</b></span>
							</div>
						</ng-template>
					</app-input-autocomplete>
				</div>
			</div>
			<div class="col-sm-3 form-group">
				<label for="onlyErrors" class="form-label">¿Solo errores?</label>
				<div class="input-group">
					<button id="onlyErrors" name="onlyErrors" (click)="onlyErrors = !onlyErrors; filter()"
						[ngClass]="onlyErrors?'btn-primary':'btn-secondary'" class="btn">
						<i [ngClass]="onlyErrors?'fa-toggle-on':'fa-toggle-off'" class="fa"></i></button>
					<input type="text" id="textOnlyErrors" name="textOnlyErrors" [value]="onlyErrors?'SI':'NO'"
						class="form-control">
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-6 form-group">
				<label for="filterWord" class="form-label">Búsqueda</label>
				<input type="text" name="filterWord" placeholder="Búsqueda por palabra" (input)="filterByWord()"
					id="filterWord" [(ngModel)]="filterWord" class="form-control">
			</div>
			<div class="col-sm-3 form-group">
				<label for="startDate" class="form-label">Fecha Inicial</label>
				<input type="date" name="startDate" (change)="filter()" id="startDate" [(ngModel)]="startDate"
					class="form-control">
			</div>
			<div class="col-sm-3 form-group">
				<label for="endDate" class="form-label">Fecha Final</label>
				<input type="date" name="endDate" (change)="filter()" id="endDate" [(ngModel)]="endDate"
					class="form-control">
			</div>
		</div>
		<div class="table-responsive mt-1" style="margin: 0;">
			<table class="table table-striped" style="margin: 0;">
				<thead>
					<tr class="tr-middle">
						<th>Fecha</th>
						<th>Empresa</th>
						<th>Usuario</th>
						<th>Nombre ZIP</th>
						<th>Tipo</th>
						<th>Nombre de XML</th>
						<th>NIT</th>
						<th>Serie</th>
						<th>Número</th>
						<th>Procesado</th>
						<th>Errores</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let item of pagination.filter"
						[class.not-processed]="!item.processed">
						<td>
							{{item.createdAt | date:'dd/MM/YYYY'}}
							<b style="font-size: 0.8em;">{{item.createdAt | date:'HH:mm'}}</b>
						</td>
						<td>{{item.companyName}}</td>
						<td>
							<b style="font-size: 0.8em;">{{item.userEmail}}</b>
						</td>
						<td>
							<span style="font-size: 0.8em;">{{item.zipFileName}}</span>
						</td>
						<td>{{item.uploadType}}</td>
						<td>
							<span style="font-size: 0.8em;">{{item.fileName}}</span>
						</td>
						<td>
							<b style="font-size: 0.8em;">Emisor</b> {{item.nitEmisor}}
							<b style="font-size: 0.8em;">Receptor</b> {{item.nitReceptor}}
						</td>
						<td>{{item.serie}}</td>
						<td>{{item.number}}</td>
						<td>
							<i [ngClass]="item.processed?'fa-circle-check text-success':'fa-circle-xmark text-danger'"
								class="fa"></i>
							{{item.processed?'SI':'NO'}}
						</td>
						<td>{{item.errorMessage}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<app-pagination-custom [elements]="pagination"></app-pagination-custom>
	</div>
</div>